/**
 * Collab is a preview, and its content does not outlive it.
 *
 * Shown under the bar on every screen, because a teacher can land on any of them from a link
 * and the date is the one thing they must not miss. It names what goes — groups, materials
 * and comments — and what to do about it, rather than only that something is ending.
 */

/** The last day of the preview. Content is deleted after it. */
export const PREVIEW_ENDS_ON = '2026-10-31';

const endsLabel = new Date(`${PREVIEW_ENDS_ON}T12:00:00Z`).toLocaleDateString('en-US', {
  month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
});

export default function PreviewNotice() {
  return (
    <aside className="collab-preview-notice" role="note" aria-label="Collab is a preview">
      <strong>Collab is a preview.</strong>{' '}
      On {endsLabel}, all groups, materials and comments will be deleted. Download anything you
      want to keep before then.
    </aside>
  );
}
